import { Skeleton } from '@focaldata/cin-ui-components'
import React from 'react'

const ProjectTitleAndStatusLoading: React.FC = () => {
  return <Skeleton height={40} width={120} />
}

export default ProjectTitleAndStatusLoading
